<template>
  <StdPageContainer :class="{ hasmask: mall_reward_status != 1 }" type="tabs">
    <template slot="title">
      <!-- 标题栏 -->
      <StdPageTitle title="商城奖励">
        <div slot="content">
          1.达到指定观看时长后，将有机会获得奖励；观看直播+回放均可支持领取奖励
          <br />
          2.观看时长定义：观看时长达到指定时间即可领取奖励，观看时长定义：同一个观众在直播间的累计时长，观众退出直播间重新进入或刷新直播间，观看时长将累计计算。需要注意：更换观众身份将重新计算观看时长
          <br />
          3.领取奖励的人数数据更新频率：10秒，建议在在活动结束后查看完整数据
        </div>
        &nbsp;
        <vh-switch
          v-model="mall_reward_status"
          @change="protocolChange"
          :active-value="1"
          :inactive-value="0"
          active-color="#FB3A32"
          inactive-color="#CECECE"
          :active-text="
            (mall_reward_status ? '已开启' : '开启后') +
            '，可使用「商城奖励」功能，观众完成指定任务即可获取奖励'
          "
        ></vh-switch>
      </StdPageTitle>
    </template>

    <!-- 内容区 -->
    <template slot="content">
      <begin-play :webinarId="$route.params.id"></begin-play>

      <!-- tabs -->
      <vh-tabs v-model="activeTab" @tab-click="handleTabClick">
        <vh-tab-pane label="直播奖励" name="0">
          <MallRewardList
            v-if="activeTab == 0"
            :webinarId="$route.params.id"
            :type="0"
            @edit="toEdit"
            @toRecord="toRecord"
            class="red-packet-list"
          ></MallRewardList>
        </vh-tab-pane>
        <vh-tab-pane label="回放奖励" name="1">
          <MallRewardList
            v-if="activeTab == 1"
            :webinarId="$route.params.id"
            :type="1"
            @edit="toEdit"
            @toRecord="toRecord"
            class="red-packet-list"
          ></MallRewardList>
        </vh-tab-pane>
      </vh-tabs>
    </template>
  </StdPageContainer>
</template>
<script>
  import { StdPageContainer, StdPageTitle } from '@vhcl/ui-console';
  import { MallRewardList } from '@vhcl/mall-rewards';
  import { sessionOrLocal } from '@/utils/utils';
  import beginPlay from '@/components/beginBtn';
  export default {
    components: {
      StdPageContainer,
      StdPageTitle,
      MallRewardList,
      beginPlay
    },
    data() {
      return {
        mall_reward_status: 0,
        activeTab: this.$route.query.tab || '0',
        dialogVisible: false,
        bound_pay_info: 0,
        bound_wechat: 0
      };
    },
    methods: {
      protocolChange(val) {
        this.$fetch('setDurationSwitch', {
          webinar_id: this.$route.params.id,
          permission_key: 'mall_reward_status',
          status: val,
          business_uid: JSON.parse(sessionOrLocal.get('userId'))
        })
          .then(res => {
            if (res.code === 200) {
              this.mall_reward_status = val;
            } else {
              this.mall_reward_status = val == 1 ? 0 : 1;
              this.$message.error(res.msg);
            }
          })
          .catch(error => {
            this.mall_reward_status = val == 1 ? 0 : 1;
            this.$message.error(error.msg);
          });
      },
      handleTabClick() {},
      toRecord(data) {
        this.$router.push({
          path: `/live/MallRewards/record/${this.$route.params.id}/${data.id}`
        });
      },
      toEdit(data) {
        this.$router.push({
          path: `/live/MallRewards/edit/${this.$route.params.id}`,
          query: data
            ? {
                id: data.id,
                type: Number(this.activeTab)
              }
            : {
                type: Number(this.activeTab)
              }
        });
      },
      getMallRewardSwitch() {
        this.$fetch('planFunctionGet', {
          webinar_id: this.$route.params.id,
          webinar_user_id: sessionOrLocal.get('userId'),
          scene_id: 1
        }).then(res => {
          if (res.code === 200) {
            this.mall_reward_status = JSON.parse(res.data.permissions).mall_reward_status;
          }
        });
      }
    },
    created() {
      this.getMallRewardSwitch();
    }
  };
</script>
<style scoped lang="less">
  .red-packet-list {
    min-height: 600px;
  }
  .hasmask {
    position: relative;
    &::before {
      content: '';
      position: absolute;
      top: 45px;
      bottom: 0;
      left: 0;
      right: 0;
      z-index: 5;
      background-color: rgba(255, 255, 255, 0.5);
    }
  }
</style>
<style lang="less">
  .cash-redpacket-dialog-content {
    line-height: 22px;
    color: #262626;
    .success {
      color: #0fba5a;
    }
  }
</style>
